import * as _ from 'lodash';
import React, { ChangeEvent, useEffect, useRef, useState } from 'react';
import { Dispatch, connect } from 'react-redux';
import { IApplicationState, AppActionCreators, OpoActionCreators, IOpoListResponse, IOpoLookupDataResponse } from '@nkr/store/index';
import { IListItem, IOpoForList, IOptnRegion, IState } from '@nkr/models/index';
import { OpoAction } from './opo-action';
import { Button, FormControl, Well } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Grid from './grid';
import Add from '../add-edit/add';
import Edit from '../add-edit/edit';
import OpoContacts from './contacts';
import OpoFiles from './files';

interface IProps {
}

interface IStateProps {
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getList: () => Promise<IOpoListResponse>,
    getLookupData: () => Promise<IOpoLookupDataResponse>,
}

type TProps = IProps & IStateProps & IDispatchProps;

const OpoList = (props: TProps) => {
    const [list, setList] = useState<IOpoForList[]>([]);
    const [search, setSearch] = useState('');
    const [add, setAdd] = useState(false);
    const [edit, setEdit] = useState<{ show: boolean, id: number }>({ show: false, id: 0 });
    const [contacts, setContacts] = useState<{ show: boolean, id: number, name: string }>({ show: false, id: 0, name: '' });
    const [files, setFiles] = useState<{ show: boolean, id: number, name: string }>({ show: false, id: 0, name: '' });
    const [stateList, setStateList] = useState<IState[]>([]);
    const [opoPositionList, setOpoPositionList] = useState<IListItem[]>([]);
    const [phoneTypeList, setPhoneTypeList] = useState<IListItem[]>([]);
    const [optnRegionList, setOptnRegionList] = useState<IOptnRegion[]>([]);
    const [show, setShow] = useState(1);

    const listRef = useRef<IOpoForList[]>(null);

    useEffect(() => {
        getData();
    }, []);

    useEffect(() => {
        listRef.current = list;
    }, [list]);

    const getData = () => {
        props.showLoading('Getting OPO list, one moment please...').then(() => {
            Promise.all([
                props.getList(),
                props.getLookupData()
            ])
                .then(([listResponse, lookupDataResponse]) => {
                    if (listResponse.data.success && lookupDataResponse.data.success) {
                        let { stateList, opoPositionList, phoneTypeList, optnRegionList } = lookupDataResponse.data.results;

                        setList(listResponse.data.results);
                        setStateList(stateList);
                        setOpoPositionList(opoPositionList);
                        setPhoneTypeList(phoneTypeList);
                        setOptnRegionList(optnRegionList);

                        // if (__ENVIRONMENT__ == 'dev') {
                        //     setFiles({
                        //         show: true,
                        //         id: 1,
                        //         name: 'Legacy of Hope'
                        //     });
                        // }
                    }

                    props.hideLoading();
                });
        });
    }

    const handleShowAdd = () => {
        setAdd(true);
    }

    const handleCancelAdd = () => {
        setAdd(false);
    }

    const handleItemSelected = async (id: number, action: number) => {
        if (action == OpoAction.Edit) {
            setEdit({
                show: true,
                id
            });
        }

        if (action == OpoAction.Contacts) {
            let opo = listRef.current.find(x => x.id == id);

            setContacts({
                show: true,
                id,
                name: opo.name
            });
        }

        if (action == OpoAction.Files) {
            let opo = listRef.current.find(x => x.id == id);

            setFiles({
                show: true,
                id,
                name: opo.name
            });
        }
    }

    const handleCancelEdit = () => {
        setEdit({
            show: false,
            id: 0
        });
    }

    const handleAddComplete = (id: number, alias: string, name: string, city: string, state: string, isActive: boolean, achApproved: boolean) => {
        let newList = _.cloneDeep(list)

        list.push({ id, alias, name, address: '', city, state, postalCode: '', isActive, achApproved, isCenter: false, contactCount: 0, hasAch: achApproved })

        setList(newList);
        setAdd(false);

        toast.success('OPO added successfully');
    }

    const handleEditComplete = (id: number, alias: string, name: string, city: string, state: string, isActive: boolean, achApproved: boolean) => {
        let newList = _.cloneDeep(list).map(item => {
            if (item.id == id) {
                item.alias = alias;
                item.name = name;
                item.city = city;
                item.state = state;
                item.isActive = isActive;
                item.achApproved = achApproved;
            }

            return item;
        });

        setList(newList);

        setEdit({
            show: false,
            id: 0
        });

        toast.success('OPO updated successfully');
    }

    const handleCloseContacts = (contactCount: number) => {
        let newList = _.cloneDeep(list).map(item => {
            if (item.id == contacts.id) {
                item.contactCount = contactCount
            }

            return item;
        });

        setList(newList);

        setContacts({
            show: false,
            id: 0,
            name: ''
        });
    };

    const handleCloseFiles = () => {
        setFiles({
            show: false,
            id: 0,
            name: ''
        });
    }

    const handleShowChange = (e: ChangeEvent<FormControl & HTMLSelectElement>) => {
        setShow(parseInt(e.currentTarget.value));
    };

    const handleSearchChange = (e: ChangeEvent<FormControl & HTMLSelectElement>) => {
        setSearch(e.currentTarget.value);
    };

    const filteredList = list.filter(x => {
        let showFilter = true;

        if (show == 1) {
            showFilter = x.isCenter == false;
        } else if (show == 2) {
            showFilter = x.isCenter == true;
        }

        let searchFilter = true;

        if (search.length >= 0) {
            searchFilter = (x.alias || '').toLowerCase().indexOf(search.toLowerCase()) >= 0 || (x.name || '').toLowerCase().indexOf(search.toLowerCase()) >= 0;
        }

        return showFilter && searchFilter;
    })

    return (
        <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: 30, marginBottom: 20 }}>
                <div style={{ fontSize: 28, fontWeight: 500 }}>OPO Management</div>
                <div style={{ textAlign: 'center' }}></div>
                <div>

                </div>
            </div>

            <Well bsSize='sm'>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <label style={{ marginBottom: 0 }}>Show:&nbsp;</label>
                        <div style={{ marginRight: 15 }}>
                            <FormControl
                                componentClass='select'
                                value={show}
                                onChange={handleShowChange}
                            >
                                <option value={0}>- ALL -</option>
                                <option value={1}>OPO</option>
                                <option value={2}>Center</option>
                            </FormControl>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <label style={{ marginBottom: 0 }}>Search:&nbsp;</label>
                            <FormControl
                                value={search}
                                placeholder='Start typing...'
                                onChange={handleSearchChange}
                            />
                        </div>
                    </div>

                    <Button bsStyle='primary' onClick={handleShowAdd}>Add OPO</Button>
                </div>
            </Well>

            <Grid
                data={filteredList}
                onItemSelected={handleItemSelected} />

            <Add
                show={add}
                stateList={stateList}
                optnRegionList={optnRegionList}
                onSaveComplete={handleAddComplete}
                onCancel={handleCancelAdd} />

            <Edit
                show={edit.show}
                id={edit.id}
                stateList={stateList}
                optnRegionList={optnRegionList}
                onSaveComplete={handleEditComplete}
                onCancel={handleCancelEdit} />

            <OpoContacts
                show={contacts.show}
                opoId={contacts.id}
                opoNkrName={contacts.name}
                positionList={opoPositionList}
                phoneTypes={phoneTypeList}
                onClose={handleCloseContacts}
            />

            <OpoFiles
                show={files.show}
                opoId={files.id}
                opoNkrName={files.name}
                // positionList={opoPositionList}
                // phoneTypes={phoneTypeList}
                onClose={handleCloseFiles}
            />
        </>
    );
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app,
        ticketing: state.ticketing,
        centers: state.centers
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getList: () => {
            return dispatch(OpoActionCreators.getList());
        },
        getLookupData: () => {
            return dispatch(OpoActionCreators.getLookupData());
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(OpoList);